// src/components/MobileMenu.jsx
import { Link } from "react-router-dom";
import { FaHome, FaListAlt, FaUser, FaShoppingCart } from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext.jsx";
import "./mobilemenu.css";

const MobileMenu = () => {
  const { user } = useContext(AuthContext);

  // Si el usuario está autenticado, se dirige a "/mi-cuenta", si no, a "/choice"
  const profileLink = user ? "/mi-cuenta" : "/choice";

  return (
    <nav className="mobile-menu">
      <Link to="/" className="mobile-menu-item">
        <FaHome />
        <span>Inicio</span>
      </Link>
      <Link to="/planes" className="mobile-menu-item">
        <FaListAlt />
        <span>Planes</span>
      </Link>
      <Link to={profileLink} className="mobile-menu-item">
        <FaUser />
        <span>Perfil</span>
      </Link>
      <Link to="/cart" className="mobile-menu-item">
        <FaShoppingCart />
        <span>Carrito</span>
      </Link>
    </nav>
  );
};

export default MobileMenu;